import React from 'react';
import emailjs from '@emailjs/browser';

const Form = () => {
  return (
    <section className="container-fluid bg-primary py-md-5">
        <div className="row">

          <div className="col-md-4 px-5 form-img mb-5 mb-sm-0">
            <img src="Images/form-img.png" alt="" />
          </div>

          <div className="col-md-7 text-white p-4 p-md-0 form-container">

            <h3 className="fw-bold">Subscribe to the Step Arena Newsletter</h3>
            <p>Don’t miss a thing! Subscribe to our newsletter and get updates straight to your inbox about new
              courses, sports events, special offers, and expert tips for a healthy lifestyle. We’re here to keep
              you informed and inspired – whether you're an athlete, a parent, or a recreational visitor.</p>

            <div className="row mt-4 form p-2 p-md-0">

              <div className="col-md-3 px-0">
                <input type="text" name="" id="" placeholder="Emri" className="w-100 rounded p-md-2 p-2" />
              </div>

              <div className="col-md-3 px-0 py-md-0 py-3 px-md-3">
                <input type="email" name="" id="" placeholder="Mbiemri" className="w-100 rounded p-md-2 p-2" />
              </div>

              <div className="col-md-6 px-0">
                <input type="text" name="" id="" placeholder="Email:" className="w-100 rounded p-md-2 p-2" />
              </div>

            </div>

          </div>

        </div>
      </section>
  )
}

export default Form
